import _ from 'lodash'
import Backbone from 'backbone'
import config from 'scoreboard/components/config'
import CollapsibleStackTrace from 'scoreboard/components/collapsible-stack-trace'
import errorStackTraceDialog from './error-stack-trace-dialog.hbs'


var ServerErrorDetailsDialog = Backbone.View.extend({

	/**
	 * @param {String} [options.title='common.error.server'] MR.p code for the error dialog title.
	 * @param {String} [options.banner]
	 * @param {String} [options.stackTrace]
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(errorStackTraceDialog(this.options))
		this.$('.dialog-body').addClass('server-error-details')

		if (!config.hideStackTraces) {
			this.collapsibleStackTrace = new CollapsibleStackTrace(this.options)
			this.$('.stack-trace').append(this.collapsibleStackTrace.el)
			this.collapsibleStackTrace.render()
		}

		// allow the dialog to be full width in development mode
		if (config.development) {
			this.$el.css('display', 'initial')
		}

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.collapsibleStackTrace], 'remove')
	}
})

export default ServerErrorDetailsDialog

ServerErrorDetailsDialog.__filename__ = 'components/server-error-details-dialog.js'
